import React from "react";
import styled from "styled-components";
import { Button } from "@blueprintjs/core";

import { KeyboardShortcutHint } from "@components/KeyboardShortcutHint";
import { runShortcut } from "@utils/util";

interface IRunButtonProps {
  onClick: (e: React.MouseEvent<HTMLElement>) => Promise<void>;
  isRunning: boolean;
  customRunText?: string;
  className?: string;
  style?: React.CSSProperties;
  disabled?: boolean;
}

const BrandButton = styled(Button)`
  && {
    height: 36px;
    font-size: var(--global-font-size-m);
  }

  && .bp3-button-text {
    display: inline-flex;
  }
`;

export const RunButton: React.FC<IRunButtonProps> = ({
  onClick,
  isRunning,
  customRunText,
  className,
  style,
  disabled,
}) => {
  return (
    <BrandButton
      className={className}
      style={style}
      intent={customRunText ? undefined : "primary"}
      onClick={onClick}
      loading={isRunning}
      disabled={disabled}
    >
      {customRunText || (
        <span>
          Run <KeyboardShortcutHint>{runShortcut}</KeyboardShortcutHint>
        </span>
      )}
    </BrandButton>
  );
};
